import 'mathlive/dist/mathlive-static.css';
import 'mathlive/dist/mathlive-fonts.css';

import './MathBlot.scss';

import { convertLatexToMarkup } from 'mathlive';
import Quill from 'quill';

const Delta = require('quill-delta');
const EmbedBlot = Quill.import('blots/embed');

class MathBlot extends EmbedBlot {
  static create(value: string) {
    const node = super.create(value);
    node.setAttribute('data-latex', value);
    const textstyle = convertLatexToMarkup(value, {
      mathstyle: 'displaystyle',
    });
    node.innerHTML = textstyle;

    // Duplicate latex in child for copy/paste preservation
    node.childNodes[0].setAttribute('data-latex', value);
    return node;
  }

  static value(node) {
    return node.getAttribute('data-latex') ?? node.textContent;
  }
  static className = 'quill-math';
  static blotName = 'math';
  static tagName = 'span';
}

// We need this matcher so that copy paste works.
const mathBlotMatcher = ['span.quill-math', (node: any, delta: any) => delta];

const mathInnerBlotMatcher = [
  ['span.ML__mathlive'],
  (node, delta) => {
    const latex = node.dataset['latex'];
    if (latex && node.parentNode.className !== MathBlot.className) {
      // When copying a math blot sometimes the child is only copied, this converts it to the proper math blot
      return new Delta([{ insert: { math: latex } }]);
    }
    return delta;
  },
];

export default MathBlot;
export { mathBlotMatcher, mathInnerBlotMatcher };
